import { logger } from '@heidi/runtime/logger';

type DictationFeedbackAnalyticsInteraction =
  | 'feedback_submitted'
  | 'reason_picker_viewed'
  | 'not_now_clicked'
  | 'see_history_clicked'
  | 'logs_reason_picker_viewed'
  | 'logs_cancel_clicked';

/** Keeps analytics failures from interrupting the feedback flow. */
export const trackFeedbackAnalyticsSafely = (
  interaction: DictationFeedbackAnalyticsInteraction,
  trackInteraction: () => void
): void => {
  try {
    trackInteraction();
  } catch (error) {
    logger.warn('[dictation/feedback] analytics failed', {
      classification: 'analytics_failed',
      interaction,
      errorName: error instanceof Error ? error.name : 'UnknownError',
    });
  }
};
